<template>
  <div class="swipe-container">
    <HowTo v-if="!showCards" @showCards="showCards = true" />
    <VehicleSwiper v-else />
  </div>
</template>

<script>
import HowTo from  '@/components/swipe/HowTo'
import VehicleSwiper from  '@/components/swipe/VehicleSwiper'

export default {
  name: 'swipe',
  components: {
    HowTo,
    VehicleSwiper
  },
  data: () => ({
    showCards: false
  })
}
</script>

<style lang="scss" scoped>
.swipe-container {
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
}
</style>